import * as hyejoogetters from '../hyejoogetters';
import * as models from '../models';

export const Getters = hyejoogetters.Getters;

export declare interface Response {
    nextPage: boolean;
    returnedFields: string[];
}

export declare interface Order extends models.Order {
    OrderProofsOther: models.OrderProof[];
}

export declare interface Orders extends Response {
    orders: Order[];
}

export declare interface Carriers extends Response {
    carriers: models.Carrier[];
}

export declare interface Quotes extends Response {
    quotes: models.Quote[];
}

export declare interface Quote extends Response {
    quote: models.Quote;
}

export declare interface Shipments extends Response {
    shipments: models.Shipment[];
}

export declare interface OrderPayments extends Response {
    orderPayments: models.OrderPayment[];
}

export declare interface ShippingOption extends models.ShippingOption {
    lastOrdered: string;
}

export declare interface ShippingOptions extends Response {
    shippingOptions: ShippingOption[];
}

export declare interface UserTaxExemption extends models.UserTaxExemption {
    default?: boolean;
}

export declare interface UserTaxExemptions extends Response {
    userTaxExemptions: UserTaxExemption[];
    userTaxExemptionReasons: models.UserTaxExemptionReason[];
}

export declare interface PaymentOptions extends Response {
    paymentOptions: models.PaymentOption[];
}
export declare interface Uploads extends Response {
    uploads: models.Upload[];
}

export declare interface Carriers extends Response {
    carriers: models.Carrier[];
}

export declare interface StockItems extends Response {
    stockItems: models.StockItem[];
}
export declare interface ChildLineItems extends Response {
    childLineItems: models.ChildLineItem[];
}

export declare interface QuoteRequestProjectTasks extends Response {
    quoteRequestProjectTasks: models.QuoteRequestProjectTask[];
    // The serving realm's minimum deposit total (the `depositFloor` company
    // detail, default $150) as a decimal string — the design-ticket prepay
    // flows charge this instead of a hardcoded $150.
    depositFloor: string;
}

export declare interface LineItemTypeSizes extends Response {
    lineItemTypeSizes: models.LineItemTypeSize[];
}

export declare interface Proofs extends Response {
    proofs: models.Proof[];
}